import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Permission } from '../../../class/permission';
import { PermissionService } from '../../../service/permission/permission.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-permission',
  templateUrl: './new-permission.component.html',
  styleUrls: ['./new-permission.component.scss']
})
export class NewPermissionComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Permission;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public permissions: AbstractControl;
    public permissionsSelected: string[];
    public description: AbstractControl;
    public activated: AbstractControl;
  

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public permissionService: PermissionService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'permissions': [''],
            'description': ['', Validators.compose([Validators.required])],
            'activated': ['', Validators.compose([Validators.required])],

        });

        this.name = this.form.controls['name'];
        this.permissions = this.form.controls['permissions'];
        this.description = this.form.controls['description'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.description.setValue(this.edit.description);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelPermission () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newPermission(values);
    }

    public newPermission(values: Permission) {
        const param = {
            'name': values.name,
            'description': values.description,
            'activated': values.activated,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.permissionService.updatePermission(this.edit.id, param)
                :
                this.permissionService.newPermission(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/permissions/new-permission/new-permission.component.ts